import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './SingleListSelectorList.scss';

const SingleListSelectorList = ({
  children,
  extraClass,
}) => {
  const wrapperClass = classnames('single-list-selector__list', {
    [extraClass]: extraClass,
  });

  return (
    <div className={wrapperClass}>
      {children}
    </div>
  );
};

SingleListSelectorList.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string,
  ]).isRequired,
  extraClass: PropTypes.string,
};

SingleListSelectorList.defaultProps = {
  extraClass: '',
};

export default SingleListSelectorList;
